// extracted by mini-css-extract-plugin
export var altFill = "AlmaLogo-module--altFill--b316b";
export var inner = "AlmaLogo-module--inner--5f03e";
export var svg = "AlmaLogo-module--svg--5e02f";